import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../service/config.service';

@Injectable({
  providedIn: 'root',
})
export class BaseUrlInterceptor implements HttpInterceptor {
  private readonly configService = inject(ConfigService);

  public intercept(
    request: HttpRequest<unknown>,
    httpHandler: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const api: string = this.configService.api;
    if (api) {
      request = request.clone({
        url: api + request.url,
      });
    }
    return httpHandler.handle(request);
  }
}
